
import { Spacer_Header } from "../components/elements/Spacer"
import ConnectIcon from "../components/elements/icons/ConnectIcon"
import PageBody from "../components/layouts/PageBody"
import { lt } from "../components/parts/LanguageText"
import SEO from "../components/parts/SEO"


export default function ConnectPage(props:any) {

	return (
		<>
			<Spacer_Header/>
			<PageBody className="pm-[120px]">
				<div className="relative flex items-center justify-center w-full h-full min-h-[calc(100vh_-_150px)]">
					<div className="">
						{/* <div className="max-w-[212px] mx-auto w-full"><MainLogo/></div> */}
						<div className="zscale-[5] mx-auto w-[100px] h-[100px] flex items-center justify-center">
							<div className="inline-block scale-[2]">
								<ConnectIcon/>
							</div>
						</div>
						<h1 className="text-center text-base font-bold mt-4">{lt("connect_page_txt_01")}</h1>
					</div>
					{/* <div className="z-[-1] absolute scale-[5] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 inline-block">
						<ConnectIcon/>
					</div> */}
				</div>
			</PageBody>
		</>
	)
}
export const Head = () => {
	return <SEO subtitle="Connecting..." slug="/connect/"/>
}